import type { PromoOffer } from '@/server/initState/getPromoOffer';

export const SET_PROMO_OFFER = 'SET_PROMO_OFFER';

export type PromoOfferState = PromoOffer | null;
